import { db } from '../firebase/config';
import { collection, doc, getDocs, setDoc, deleteDoc, serverTimestamp } from 'firebase/firestore';

/**
 * Admin-set normalization multipliers, stored one document per exercise in
 * `exerciseOverrides`.
 *
 * Only exercises that have been retuned get a document. An exercise still on its
 * shipped multiplier has no document at all, so clearing an override is a delete
 * rather than a write of the default - that way a later change to the shipped
 * number in code still reaches everyone who never touched it.
 */
export async function getMultiplierOverrides(): Promise<Record<string, number>> {
  const snap = await getDocs(collection(db, 'exerciseOverrides'));
  const overrides: Record<string, number> = {};
  snap.forEach((d) => {
    const value = d.data().normalizationMultiplier;
    if (typeof value === 'number' && value > 0) overrides[d.id] = value;
  });
  return overrides;
}

export async function setMultiplierOverride(
  exerciseId: string,
  normalizationMultiplier: number,
): Promise<void> {
  await setDoc(doc(db, 'exerciseOverrides', exerciseId), {
    normalizationMultiplier,
    updatedAt: serverTimestamp(),
  });
}

export async function clearMultiplierOverride(exerciseId: string): Promise<void> {
  await deleteDoc(doc(db, 'exerciseOverrides', exerciseId));
}
